import { updateState } from "@angular-architects/ngrx-toolkit";
import { signalStoreFeature, withMethods, withState } from "@ngrx/signals";

export interface LoadingAndErrorState {
    error: unknown;
    loading: boolean;
}

const initialState: LoadingAndErrorState = {
    error: null,
    loading: false
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function withLoadingAndError(storeName: string) {
    return signalStoreFeature(
        withState(initialState),
        withMethods((store) => ({
            setError(error: unknown): void {
                updateState(store, `[${storeName}] setError`, { error });
            },
            setLoading(loading: boolean): void {
                updateState(store, `[${storeName}] setLoading`, { loading });
            }
        }))
    );
}
